import { useParams } from "react-router";
import { useRltWorkOrderShowQuery } from "@/services/backend/rlt/work-orders/api/work-order-api";
import { PricingCards } from "@/services/backend/rlt/pricing/components/pricing-cards";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

export function WorkOrderCompletionPricingRoute() {
  const { workOrderId } = useParams();
  const { data } = useRltWorkOrderShowQuery({ id: workOrderId! });

  return (
    <PricingCards
      pricingId={data!.pricingId}
      disabled={isImmutable(data!)}
      showPostExecutionReduction
    />
  );
}
